<!-- 根据员工检索 -->
<template>
  <div class="hello">
    <div class="one">
      <div class="staffo_home_nav">
        <span>员工列表</span>
      </div>
      <div class="staffo_home_body">
        <div style="display: flex; justify-content: center">
          <el-input clearable placeholder="搜索员工" prefix-icon="el-icon-search" v-model="input1" style="width: 80%"
                    @change="searchStaff()">
            <el-button slot="append" type="primary" @click="searchStaff()">搜索</el-button>
          </el-input>
        </div>
        <div class="staffo_home_body_section">
          <span>部门</span>
          <span>员工</span>
        </div>
        <div style="display: flex">
          <!-- 员工列表里的部门渲染 -->
          <div style="
                margin-top: 10px;
                display: inline-block;
                float: left;
                width: 50%;
              ">
            <el-tree class="yuanggong" style="background-color: none" :data="data" :props="defaultProps"
                     :highlight-current="true" @node-click="handleNodeClick"></el-tree>
          </div>
          <!-- 员工列表里的员工渲染 -->
          <div style="
                margin-top: 10px;
                display: inline-block;
                float: right;
                width: 50%;
              ">
            <el-tree style="background-color: none" :data="dataid" :props="defaultPropsid" :highlight-current="true"
                     @node-click="handleNodeClickid"></el-tree>
          </div>
        </div>
      </div>
    </div>
    <!-- 会话列表 -->
    <div class="two">
      <div class="staffo_home_nav">
        <span>会话列表</span>
      </div>
      <div class="staffo_home_body">
        <div style="display: flex; justify-content: center">
          <el-input clearable placeholder="搜索员工" prefix-icon="el-icon-search" v-model="input2" style="width: 80%"
                    @change="searchList">
            <el-button slot="append" type="primary" @click="searchList()">搜索</el-button>
          </el-input>
        </div>
        <div class="select">
          <span @click="interior()" :class="conversation.interior == true ? 'gain' : 'no_gain'">内部</span>
          <span @click="external()" :class="conversation.external == true ? 'gain' : 'no_gain'">外部</span>
          <span @click="group()" :class="conversation.group == true ? 'gain' : 'no_gain'">群聊</span>
        </div>
        <!-- 内部 -->
        <div v-if="conversation.interior == true">
          <div class="interior">
            <el-tree style="background-color: none" :data="data_interior" :props="defaultProps_interior"
                     :highlight-current="true" @node-click="handleNodeClick_interior"></el-tree>
          </div>
        </div>
        <!-- 外部 -->
        <div v-else-if="conversation.external == true">
          <div class="interior">
            <el-tree style="background-color: none" :data="data_external" :props="defaultProps_external"
                     :highlight-current="true" @node-click="handleNodeClick_external"></el-tree>
          </div>
        </div>
        <!-- 群聊 -->
        <div v-else-if="conversation.group == true">
          <div class="interior">
            <el-tree style="background-color: none" :data="data_group" :props="defaultProps_group"
                     :highlight-current="true" @node-click="handleNodeClick_group"></el-tree>
          </div>
        </div>
      </div>
    </div>
    <div class="three">
      <div class="staffo_home_nav">
        <span>{{ conversation_name.dataid_name }}</span>
      </div>
      <div class="staffo_home_body">
        <div class="block" style="margin-left: 20px; display: flex">
          <div>
            <el-date-picker v-model="value1" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                            end-placeholder="结束日期" @change="content_date"></el-date-picker>
          </div>
          <div style="margin: 0 0 0 20px; display: flex; justify-content: center">
            <el-input clearable placeholder="内容搜索" prefix-icon="el-icon-search" @input="content_seek()" v-model="input3">
              <el-button slot="append" type="primary" @click="content_seek()">搜索</el-button>
            </el-input>
          </div>
        </div>
        <div class="staff">
          <span @click="all()" :class="right.all == true ? 'gain' : 'no_gain'">全部</span>
          <span @click="file()" :class="right.file == true ? 'gain' : 'no_gain'">文件</span>
          <span @click="picture()" :class="right.picture == true ? 'gain' : 'no_gain'">图片</span>
          <span @click="red()" :class="right.red == true ? 'gain' : 'no_gain'">红包</span>
          <span @click="voice()" :class="right.voice == true ? 'gain' : 'no_gain'">语音</span>
          <span @click="video()" :class="right.video == true ? 'gain' : 'no_gain'">视频</span>
        </div>
        <!-- v-infinite-scroll="load" -->
        <div class="chatting_records" v-infinite-scroll="load" :infinite-scroll-disabled="isInfiniteScrollDisabled">
          <div v-for="(item, index) in liaotjl" :key="index">
            <div v-if="item.from == conversation_id.dataid_userid.name" class="chatting_records_fasong">
              <div class="information">
                <div class="information_name">
                  {{ (item.msgtime * 1000) | formatDate }}&nbsp;{{
                    conversation_id.dataid_userid.name
                  }}
                </div>
                <div :class="item.msgtype == 'voice' ? '' : 'conversation_body'">
                  <div v-if="item.msgtype == 'text'">
                    <div v-emotion="item.content"></div>
                    <!-- {{item.content}}   -->
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- <div v-if="item.msgtype=='text'||item.is_revoke==1" v-emotion="item.content">
                      <div v-if="item.is_revoke==1" style="font-size:16px;color:rgb(255, 79, 79)">此消息被撤回</div>
                      </div> -->
                  <!-- 聊天记录转发 -->
                  <div v-if="item.msgtype == 'chatrecord'" class="name_chatrecord">
                    转发了{{ item.chatrecord_title }}的聊天记录
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 代办的来源文本 -->
                  <div v-if="item.msgtype == 'todo'">
                    代办的具体内容{{ item.todo_content }}代办的来源文本{{
                      item.todo_title
                    }}
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 在线文档 -->
                  <div v-if="item.msgtype == 'docmsg'">
                    <a :href="item.msgtime" :download="item.doc_title + '.' + item.md5sum">
                      <div class="name_docmsg">
                        <div class="abc">
                          <div class="name_docmsg_name">
                            {{ item.doc_title }}
                          </div>
                          <div class="name_docmsg_haha">
                            {{ item.doc_creator }}
                          </div>
                        </div>
                        <img src="../../assets/7775c3b888bec401c922129ff6e51e8.png" alt />
                      </div>
                    </a>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 会议主题 -->
                  <div v-if="item.msgtype == 'meeting'" class="meeting">
                    <!-- 会议主题{{item.meeting_topic}}会议开始时间{{item.meeting_starttime}}会议结束时间{{item.meeting_endtime}}会议地址{{item.meeting_address}}会议备注{{item.meeting_remarks}}会议消息类型{{item.meeting_meetingtype}}会议id：{{item.meeting_meetingid}}会议邀请处理状态{{item.meeting_status}} -->
                    <div class="conference">
                      <div>{{ item.meeting_topic }}</div>
                      <div>
                        <div>
                          {{ (item.meeting_starttime * 1000) | formatDate }}
                        </div>
                      </div>
                      <div>
                        <img src="../../assets/fc182b70e7ea02dc500ed48b362f04c.png" alt="" />
                        <span>&nbsp;&nbsp;会议邀约</span>
                      </div>
                    </div>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 红包 -->
                  <div v-if="item.msgtype == 'redpacket'">
                    <div class="sbe">
                      <div class="sbe_body">
                        <div :title="item.packet_wish">
                          {{ item.packet_wish }}
                        </div>
                        <div>{{ item.packet_totalamount / 100 }}元</div>
                      </div>
                    </div>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 图片 -->
                  <div v-if="item.msgtype == 'image'">
                    <img class="aboutno" :src="item.filepath" alt @click="(onSubmitsc = true), asuebn(item)" />
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 视频 -->
                  <div v-if="item.msgtype == 'video'">
                    <!-- 视频大小{{item.filesize}}视频时长{{item.play_length}}视频路径{{item.filepath}} -->
                    <video width="200px" height="auto" controls>
                      <source :src="item.filepath" type="video/mp4" />
                      <source :src="item.filepath" type="video/ogg" />
                      <source :src="item.filepath" type="video/webm" />
                      您的浏览器不支持 video 属性。
                    </video>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 小程序 -->
                  <div v-if="item.msgtype == 'weapp'">
                    <div class="weapp_body">
                      <div class="weapp_nav">
                        <main class="weapp_img">
                          <img src="../../assets/a86fca681961a1a99ed32d2f5e9de99.png" alt />
                        </main>
                        <span class="weapp_text">{{
                            item.weapp_displayname
                          }}</span>
                      </div>
                      <div class="weapp_imgs">
                        <div class="weapp_imgs_text">
                          {{ item.weapp_title }}
                        </div>
                        <div class="weapp_imgs_img">
                          <img src="../../assets/0c18a7870bb0d17f0664dbb25c6e3c2.png" alt />
                        </div>
                      </div>
                      <div class="weapp_bottom">
                        <img src="../../assets/f6a22a13a1b1fad962a59a7fac5071d.png" alt />
                        <span>小程序</span>
                      </div>
                    </div>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 地图 -->
                  <div v-if="item.msgtype == 'location'">
                    <img :src="
                      `https://apis.map.qq.com/ws/staticmap/v2/?center=` +
                      item.latitude +
                      `,` +
                      item.longitude +
                      `&zoom=15&size=300*300&maptype=roadmap&markers=size:large|color:0xFFCCFF|label:k|` +
                      item.latitude +
                      `,` +
                      item.longitude +
                      `&key=6CTBZ-WPRC3-A7J3F-YJKJB-IBH32-G6F4J`
                    " alt="" />
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 直播 -->
                  <div v-if="item.msgtype == 'link'">
                    <div class="link_zhibo">
                      <div class="link_imges">
                        <img :src="item.link_image_url" alt />
                        <span>企业微信直播</span>
                      </div>
                      <div class="link_biaoti">{{ item.link_title }}</div>
                    </div>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- <div v-if="item.msgtype=='revoke'">{{item.link_image_url}}</div> -->
                  <!-- 语音 -->
                  <div v-if="item.msgtype == 'voice'">
                    <m-audio :src="item.filepath" class="buoo right"></m-audio>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 文件 -->
                  <div v-if="item.msgtype == 'file'">
                    <a :href="item.filepath" :download="item.doc_title + '.' + item.md5sum">
                      <div class="name_docmsg">
                        <div class="abc">
                          <div class="name_docmsg_name">
                            {{ item.filename }}
                          </div>
                          <div class="name_docmsg_haha">文件</div>
                        </div>
                        <img src="../../assets/7775c3b888bec401c922129ff6e51e8.png" alt />
                      </div>
                    </a>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <div v-if="item.msgtype == 'emotion'">
                    <img :src="item.filepath" alt="" />
                  </div>
                </div>
              </div>
              <img :src="conversation_id.dataid_userid.avatar" alt class="touxiang" />
            </div>

            <div v-else class="else_left">
              <img :src="item.avatar" alt="" />
              <div class="name_left">
                <div class="information_left">
                  {{ item.from }} &nbsp;{{ (item.msgtime * 1000) | formatDate }}
                </div>
                <div :class="item.msgtype == 'voice' ? '' : 'conversation_left'">
                  <div v-if="item.msgtype == 'text'">
                    <div v-emotion="item.content"></div>
                    <!-- {{item.content}} -->
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- <div v-if="item.is_revoke==1" style="font-size:16px;color:rgb(255, 79, 79)">此消息被撤回</div> -->
                  <!-- 聊天记录转发 -->
                  <div v-if="item.msgtype == 'chatrecord'" class="name_chatrecord">
                    转发了{{ item.chatrecord_title }}的聊天记录
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 代办的来源文本 -->
                  <div v-if="item.msgtype == 'todo'">
                    代办的具体内容{{ item.todo_content }}代办的来源文本{{
                      item.todo_title
                    }}
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 在线文档 -->
                  <div v-if="item.msgtype == 'docmsg'">
                    <a :href="item.msgtime" :download="item.doc_title + '.' + item.md5sum">
                      <div class="name_docmsg">
                        <div class="abc">
                          <div class="name_docmsg_name">
                            {{ item.doc_title }}
                          </div>
                          <div class="name_docmsg_haha">
                            {{ item.doc_creator }}
                          </div>
                        </div>
                        <img src="../../assets/7775c3b888bec401c922129ff6e51e8.png" alt />
                      </div>
                    </a>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 会议主题 -->
                  <div v-if="item.msgtype == 'meeting'" class="meeting">
                    <!-- 会议主题{{item.meeting_topic}}会议开始时间{{item.meeting_starttime}}会议结束时间{{item.meeting_endtime}}会议地址{{item.meeting_address}}会议备注{{item.meeting_remarks}}会议消息类型{{item.meeting_meetingtype}}会议id：{{item.meeting_meetingid}}会议邀请处理状态{{item.meeting_status}} -->
                    <div class="conference">
                      <div>{{ item.meeting_topic }}</div>
                      <div>
                        <div>
                          {{ (item.meeting_starttime * 1000) | formatDate }}
                        </div>
                      </div>
                      <div>
                        <img src="../../assets/fc182b70e7ea02dc500ed48b362f04c.png" alt="" />
                        <span>&nbsp;&nbsp;会议邀约</span>
                      </div>
                      <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                        此消息被撤回
                      </div>
                    </div>
                  </div>
                  <!-- 红包 -->
                  <div v-if="item.msgtype == 'redpacket'">
                    <!-- 红包类型{{item.packet_type}}红包祝福语{{item.packet_wish}}红包个数{{item.packet_totalcnt}}红包金额{{item.packet_totalamount}} -->
                    <div class="sbe">
                      <div class="sbe_body">
                        <div :title="item.packet_wish">
                          {{ item.packet_wish }}
                        </div>
                        <div>{{ item.packet_totalamount / 100 }}元</div>
                      </div>
                      <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                        此消息被撤回
                      </div>
                    </div>
                  </div>
                  <!-- 图片 -->
                  <div v-if="item.msgtype == 'image'">
                    <img class="aboutno" :src="item.filepath" alt @click="(onSubmitsc = true), asuebn(item)" />
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 视频 -->
                  <div v-if="item.msgtype == 'video'">
                    <!-- 视频大小{{item.filesize}}视频时长{{item.play_length}}视频路径{{item.filepath}} -->
                    <video width="200px" height="auto" controls>
                      <source :src="item.filepath" type="video/mp4" />
                      <source :src="item.filepath" type="video/ogg" />
                      <source :src="item.filepath" type="video/webm" />
                      您的浏览器不支持 video 属性。
                    </video>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 小程序 -->
                  <div v-if="item.msgtype == 'weapp'">
                    <div class="weapp_body">
                      <div class="weapp_nav">
                        <main class="weapp_img">
                          <img src="../../assets/a86fca681961a1a99ed32d2f5e9de99.png" alt />
                        </main>
                        <span class="weapp_text">{{
                            item.weapp_displayname
                          }}</span>
                      </div>
                      <div class="weapp_imgs">
                        <div class="weapp_imgs_text">
                          {{ item.weapp_title }}
                        </div>
                        <div class="weapp_imgs_img">
                          <img src="../../assets/0c18a7870bb0d17f0664dbb25c6e3c2.png" alt />
                        </div>
                      </div>
                      <div class="weapp_bottom">
                        <img src="../../assets/f6a22a13a1b1fad962a59a7fac5071d.png" alt />
                        <span>小程序</span>
                      </div>
                    </div>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 地图 -->
                  <div v-if="item.msgtype == 'location'">
                    <img :src="
                      `https://apis.map.qq.com/ws/staticmap/v2/?center=` +
                      item.latitude +
                      `,` +
                      item.longitude +
                      `&zoom=15&size=300*300&maptype=roadmap&markers=size:large|color:0xFFCCFF|label:k|` +
                      item.latitude +
                      `,` +
                      item.longitude +
                      `&key=6CTBZ-WPRC3-A7J3F-YJKJB-IBH32-G6F4J`
                    " alt="" />
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 直播 -->
                  <div v-if="item.msgtype == 'link'">
                    <div class="link_zhibo">
                      <div class="link_imges">
                        <img :src="item.link_image_url" alt />
                        <span>企业微信直播</span>
                      </div>
                      <div class="link_biaoti">{{ item.link_title }}</div>
                    </div>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 撤回 -->
                  <!-- <div v-if="item.msgtype=='revoke'">{{item.link_image_url}}</div> -->
                  <!-- 语音 -->
                  <div v-if="item.msgtype == 'voice'">
                    <!-- <embed height="50" width="150" autostart="false" loop="false"  style="background-color:none">  -->
                    <m-audio :src="item.filepath" class="buoo"></m-audio>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <!-- 文本 -->
                  <div v-if="item.msgtype == 'file'">
                    <a :href="item.filepath" :download="item.md5sum + '.' + item.fileext">
                      <div class="name_docmsg">
                        <div class="abc">
                          <div class="name_docmsg_name">
                            {{ item.filename }}
                          </div>
                          <div class="name_docmsg_haha">文件</div>
                        </div>
                        <img src="../../assets/7775c3b888bec401c922129ff6e51e8.png" alt />
                      </div>
                    </a>
                    <div v-if="item.is_revoke == 1" style="font-size: 16px; color: rgb(255, 79, 79)">
                      此消息被撤回
                    </div>
                  </div>
                  <div v-if="item.msgtype == 'emotion'">
                    <img :src="item.filepath" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="查看图片" :visible.sync="onSubmitsc" width="80%">
      <img :src="imgse" alt="" style="width: 100%; height: auto" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitsc = false">取 消</el-button>
        <el-button type="primary" @click="onSubmitsc = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { wxConfig } from "@/mixins/weixin.js";
// import audio from  "vue-mobile-audio"
import qs from "qs";
import { timeStamp } from "console";
export default {
  mixins: [wxConfig],
  name: "staff",
  data() {
    return {
      onSubmitsc: false,
      imgse: "",
      title: [],
      right: "right",
      tooken: "",
      conversation: {
        interior: true, //内部 显示隐藏
        external: false, //外部 显示隐藏
        group: false, //群聊 显示隐藏
      },
      right: {
        all: true, //全部 显示隐藏
        file: false, // 文件 显示隐藏
        picture: false, //图片 显示隐藏
        red: false, // 红包 显示隐藏
        voice: false, //语音 显示隐藏
        video: false,
      },
      dataid: [], //员工列表里的员工列表
      defaultPropsid: {
        children: "children",
        label: "name",
      },
      value1: "",
      input1: "", //员工搜索
      input2: "", //会话搜索
      input3: "", //内容搜索

      data_group: [], //群聊会话列表获取
      defaultProps_group: {
        //群聊会话列表获取
        children: "children",
        label: "name",
      },
      data_external: [], //外部会话列表
      defaultProps_external: {
        //外部会话列表获取
        children: "children",
        label: "name",
      },
      data_interior: [], //内部会话列表
      defaultProps_interior: {
        //内部会话列表获取
        children: "children",
        label: "name",
      },
      conversation_id: {
        dataid_userid: [], //员工列表里的员工列表
        group_userid: [], //群聊会话列表获取
        chat_id: [],
      },
      conversation_name: {
        //某某与某某的聊天记录
        dataid_name: "",
      },
      liaotjl: [], //聊天内容
      data: [], //部门员工
      defaultProps: {
        children: "children",
        label: "label",
      },
      useridfo: "",
      fenlei: "", //聊天记录消息类型
      kaissj: "", //开始时间
      jssj: "",
      yeshu: 1,
      // haha:'AHui'
      shijgl: {
        from: "",
        tolist: "",
        content: "",
        msgtime: "",
      },
      isInfiniteScrollDisabled: false,
      conData:''
    };
  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    },
  },
  watch: {
    liaotjl(old) {
      old = this.liaotjl;
      // console.log(old);
    },
    // b:{//深度监听，可监听到对象、数组的变化
    //      handler(val, oldVal){
    //          // console.log("b.c: "+val.c, oldVal.c);
    //      },
    //      deep:true //true 深度监听
    //  }
  },
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    //   let title = JSON.parse(window.sessionStorage.getItem("title"));
    //   // // console.log(userinfo);
    //   this.title = title;
    //   // // console.log(this.title);
    //   var a = document.title;
    //   document.title = title[0].website + "-" + a;
    //   // // console.log(this.username);
    // }
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
    }
    this.shuxingkongjian();
    this.aaaaa();
  },

  methods: {

    asuebn(val) {
      this.imgse = val.filepath;


    },

    aaaaa() {
      this.liaotjl = [];
      if (window.sessionStorage.getItem("content")) {
        let content = JSON.parse(window.sessionStorage.getItem("content"));
        this.shijgl.content = content;
      }
      if (window.sessionStorage.getItem("from")) {
        let from = JSON.parse(window.sessionStorage.getItem("from"));
        this.shijgl.from = from;
      }
      if (window.sessionStorage.getItem("tolist")) {
        let tolist = JSON.parse(window.sessionStorage.getItem("tolist"));
        this.shijgl.tolist = tolist;
      }
      if (window.sessionStorage.getItem("msgtime")) {
        let msgtime = JSON.parse(window.sessionStorage.getItem("msgtime"));
        this.shijgl.msgtime = msgtime;
      }
      var timestamp = Date.parse(new Date());
      timestamp = timestamp / 1000;

      this.axios
          .post(
              "/home/record/getChatInfo",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                from: this.shijgl.from,
                tolist: this.shijgl.tolist,
                start_time: this.shijgl.msgtime,
                end_time: timestamp,
                page: this.yeshu,
              }),
              { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.liaotjl = res.data.data;
            this.yeshu++;
          })
          .catch(function (err) {
            console.log(err);
          });
    },
    //   时间搜索content_date
    content_date() {
      this.liaotjl = [];
      this.yeshu = 1;
      let a = "";
      let b = "";
      if (Array.isArray(this.value1)) {
        b = new Date(this.value1[0]).getTime();
        a = new Date(this.value1[1]).getTime();
        b = (b * 1) / 1000;
        a = (a * 1) / 1000;
      }
      this.kaissj = b;
      this.jssj = a;
      if (
          this.conversation.interior == true ||
          this.conversation.external == true
      ) {
        var  id
        if(this.conversation.external == true){//外部
          id= this.conversation_id.group_userid.external_userid
        }else{
          id= this.conversation_id.group_userid.userid
        }

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: id,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  content: this.input3,

                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.group == true) {

        this.axios
            .post(
                "/home/department/getChatContent",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  chat_id: this.conversation_id.chat_id,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  content: this.input3,
                  id: this.conversation_id.chat_id.id,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  name: this.conversation_id.chat_id.name,
                  status: this.conversation_id.chat_id.status,
                  owner: this.conversation_id.chat_id.owner,
                  create_time: this.conversation_id.chat_id.create_time,
                  account_id: this.conversation_id.chat_id.account_id,
                  label_group_id:this.conversation_id.chat_id.label_group_id ,
                  notice: this.conversation_id.chat_id.notice,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              //this.conversation_id.group_userid = res.data.data;
              this.yeshu++;
            })
            .catch(function (err) {
              console.log(err);
            });
      }
    },
    //   内容搜索
    content_seek() {
      this.liaotjl = [];
      this.yeshu = 1;


      if (
          this.conversation.interior == true ||
          this.conversation.external == true
      ) {

        var  id
        if(this.conversation.external == true){//外部
          id= this.conversation_id.group_userid.external_userid
        }else{
          id= this.conversation_id.group_userid.userid
        }


        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: id,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  content: this.input3,

                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.group == true) {

        this.axios
            .post(
                "/home/department/getChatContent",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  content: this.input3,
                  id: this.conversation_id.chat_id.id,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  name: this.conversation_id.chat_id.name,
                  status: this.conversation_id.chat_id.status,
                  owner: this.conversation_id.chat_id.owner,
                  create_time: this.conversation_id.chat_id.create_time,
                  account_id: this.conversation_id.chat_id.account_id,
                  label_group_id:this.conversation_id.chat_id.label_group_id ,
                  notice: this.conversation_id.chat_id.notice,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.conversation_id.group_userid = res.data.data;
              this.yeshu++;
            })
            .catch(function (err) {
              console.log(err);
            });
      }
    },
    // 列表查询
    searchList() {
      this.liaotjl = [];
      this.yeshu = 1;
      if (this.conversation.group) {
        this.searchGroup();
      } else if (this.conversation.external) {
        this.searchOuter();
      } else {
        this.searchInner();
      }
    },
    // 内部搜索
    searchInner() {
      this.data_interior = []
      this.clearchaxun()
      this.axios
          .post(
              "/home/department/getInnerUser",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                userid: this.useridfo,
                username: this.input2,
              }),
              { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {

            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.data_interior = res.data.data;
          })
          .catch(function (err) {
            console.log(err);
          });
    },
    // 外部搜索
    searchOuter() {
      this.data_external = []
      this.axios
          .post(
              "/home/department/getExternalUser",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                userid: this.useridfo,
                username: this.input2,
              }),
              { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.data_external = res.data.data;
          })
          .catch(function (err) {
            console.log(err);
          });
    },
    // 群聊搜索
    searchGroup() {
      this.data_group = []
      this.axios
          .post(
              "/home/department/getGroupUser",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                username: this.input2,
                userid: this.useridfo,
              }),
              { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.data_group = res.data.data;
          })
          .catch(function (err) {
            console.log(err);
          });
    },
    //   员工搜索
    searchStaff() {
      this.liaotjl = [];
      this.yeshu = 1;
      this.axios
          .post(
              "/home/department/searchSessionUser",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                name: this.input1,
              }),
              { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            // console.log(res);
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.dataid = res.data.data;
            // // console.log(this.data);
          })
          .catch(function (err) {
            // // console.log(err);
          });
      // console.log(this.liaotjl);
    },
    // 群聊会话列表
    handleNodeClick_group(data) {
      this.liaotjl = [];
      this.yeshu = 1;
      this.conversation_name.dataid_name = data.name + "群聊内容";
      this.conversation_id.chat_id = data;
      this.isInfiniteScrollDisabled = true;
      this.axios
          .post(
              "/home/department/getChatContent",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                start_time: this.kaissj,
                end_time: this.jssj,
                page: this.yeshu,
                msgtype: this.fenlei,
                // chat_id: data.chat_id,
                id: this.conversation_id.chat_id.id,
                chat_id: this.conversation_id.chat_id.chat_id,
                name: this.conversation_id.chat_id.name,
                status: this.conversation_id.chat_id.status,
                owner: this.conversation_id.chat_id.owner,
                create_time: this.conversation_id.chat_id.create_time,
                account_id: this.conversation_id.chat_id.account_id,
                label_group_id:this.conversation_id.chat_id.label_group_id ,
                notice: this.conversation_id.chat_id.notice,
                content: this.input3,
              }),
              { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.liaotjl = res.data.data;
            this.conversation_id.group_userid = res.data.data;
            this.yeshu++;
            this.isInfiniteScrollDisabled = false;
          })
          .catch(function (err) {
            console.log(err);
          });
    },
    // 通过点击外部会话列表来获取聊天记录
    handleNodeClick_external(data) {
      this.liaotjl = [];
      this.yeshu = 1;
      this.clearchaxun()
      // 外部会话列表
      this.conversation_id.group_userid = data;
      this.conData=data
      this.conversation_name.dataid_name =
          this.conversation_id.dataid_userid.name +
          "与" +
          data.name +
          "的聊天记录";
      this.isInfiniteScrollDisabled = true;
      if (this.right.all == true) {

        //全部
        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: data.external_userid,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  msgtype: this.fenlei,
                  content: this.input3,
                  page: this.yeshu,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.right.file == true) {

        //文件
        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: data.external_userid,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  msgtype: this.fenlei,
                  content: this.input3,
                  page: this.yeshu,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.right.picture == true) {
        //图片
        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: data.external_userid,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  msgtype: this.fenlei,
                  content: this.input3,
                  page: this.yeshu,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.right.red == true) {
        //红包
        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: data.external_userid,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  msgtype: this.fenlei,
                  content: this.input3,
                  page: this.yeshu,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.right.voice == true) {
        //语音
        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: data.external_userid,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  msgtype: this.fenlei,
                  content: this.input3,
                  page: this.yeshu,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.right.video == true) {
        //视频
        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: data.userid,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  msgtype: this.fenlei,
                  content: this.input3,
                  page: this.yeshu,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      }
    },
    // 通过点击内部会话列表来获取聊天记录
    handleNodeClick_interior(data) {
      this.liaotjl = [];
      this.yeshu = 1;
      this.clearchaxun()
      this.conversation_id.group_userid = data;
      this.conversation_name.dataid_name =
          this.conversation_id.dataid_userid.name +
          "与" +
          data.name +
          "的聊天记录";
      this.isInfiniteScrollDisabled = true;
      if (this.right.all == true) {
        //全部
        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: data.userid,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  content: this.input3,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.right.file == true) {
        //文件
        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: data.userid,
                  msgtype: "file",
                  page: this.yeshu,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.right.picture == true) {
        //图片
        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: data.userid,
                  msgtype: "image",
                  page: this.yeshu,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.right.red == true) {
        //红包
        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: data.userid,
                  msgtype: "redpacket",
                  page: this.yeshu,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.right.voice == true) {
        //语音
        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: data.userid,
                  msgtype: "voice",
                  page: this.yeshu,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.right.video == true) {
        //视频
        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: data.userid,
                  msgtype: "video",
                  page: this.yeshu,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      }
    },
    // 员工列表里的员工渲染
    handleNodeClickid(data) {
      this.liaotjl = [];
      this.yeshu = 1;
      // console.log(data);
      this.conversation_id.dataid_userid = data;
      this.useridfo = data.userid;
      // console.log(data.userid);
      this.clearchaxun()
      if (this.conversation.interior == true) {
        this.axios
            .post(
                "/home/department/getInnerUser",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  userid: this.conversation_id.dataid_userid.userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              // console.log(res);
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.data_interior = res.data.data;
              // // console.log(this.data);
            })
            .catch(function (err) {
              // // console.log(err);
            });
      } else if (this.conversation.external == true) {
        // /home/department/getExternalUser
        this.axios
            .post(
                "/home/department/getExternalUser",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  userid: this.conversation_id.dataid_userid.userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              // console.log(res);
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.data_external = res.data.data;
              // // console.log(this.data);
            })
            .catch(function (err) {
              // // console.log(err);
            });
      } else if (this.conversation.group == true) {
        this.axios
            .post(
                "/home/department/getGroupUser",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  userid: this.conversation_id.dataid_userid.userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              // console.log(res);
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.data_group = res.data.data;
              // // console.log(this.data);
            })
            .catch(function (err) {
              // // console.log(err);
            });
      }

      // console.log(this.liaotjl);
    },
    clearchaxun(){
      //时间清空  搜索清空
      this.input3 = ""
      this.value1 = ""
    },
    // 员工列表里的部门渲染
    handleNodeClick(data) {
      this.liaotjl = [];
      // // console.log(data);
      this.yeshu = 1;
      this.clearchaxun()
      this.axios
          .post(
              "/home/department/getUserDepartment",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                department_id: data.id,
              }),
              { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            // console.log(res);
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            if (res.data.code == 1) {
              this.dataid = res.data.data;
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
            // // console.log(this.data);
          })
          .catch(function (err) {
            // // console.log(err);
          });
      // console.log(this.liaotjl);
    },
    // 渲染树形控件部门
    shuxingkongjian() {
      this.liaotjl = [];
      this.yeshu = 1;
      this.axios
          .post(
              "/home/department/getDepartmentName",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
              }),
              { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            // console.log(res);
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.data = res.data.data;
            // console.log(this.data);
          })
          .catch(function (err) {
            // // console.log(err);
          });
      // console.log(this.liaotjl);
    },

    //内部 显示隐藏
    interior() {
      this.liaotjl = [];
      this.yeshu = 1;
      this.conversation.interior = true;
      this.conversation.external = false;
      this.conversation.group = false;
      this.clearchaxun()
      this.axios
          .post(
              "/home/department/getInnerUser",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                userid: this.conversation_id.dataid_userid.userid,
              }),
              { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            // console.log(res);
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.data_interior = res.data.data;
            // // console.log(this.data);
          })
          .catch(function (err) {
            // // console.log(err);
          });
      // console.log(this.liaotjl);
    },
    //外部 显示隐藏
    external() {
      this.liaotjl = [];
      this.yeshu = 1;
      this.conversation.interior = false;
      this.conversation.external = true;
      this.conversation.group = false;
      this.clearchaxun()
      // /home/department/getExternalUser
      this.axios
          .post(
              "/home/department/getExternalUser",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                userid: this.conversation_id.dataid_userid.userid,
              }),
              { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            // console.log(res);
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.data_external = res.data.data;
            // // console.log(this.data);
          })
          .catch(function (err) {
            // // console.log(err);
          });
      // console.log(this.liaotjl);
    },
    //群聊 显示隐藏
    group() {
      this.liaotjl = [];
      this.yeshu = 1;
      this.conversation.interior = false;
      this.conversation.external = false;
      this.conversation.group = true;
      this.clearchaxun()
      this.axios
          .post(
              "/home/department/getGroupUser",
              qs.stringify({
                usertoken: this.tooken.usertoken,
                account_id: this.tooken.account_id,
                phone: this.tooken.phone,
                userid: this.conversation_id.dataid_userid.userid,
              }),
              { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            // console.log(res);
            if (res.data.msg == "登录超时") {
              this.$router.push("/register");
            }
            this.data_group = res.data.data;
            // // console.log(this.data);
          })
          .catch(function (err) {
            // // console.log(err);
          });
      // console.log(this.liaotjl);
    },

    /* 判断是不是从敏感词进的*/
    lujing(){
      var from = this.$route.query.from
      var tolist =this.$route.query.tolist
      if(from&&tolist){
        this.conversation_id.dataid_userid.userid=this.$route.query.from
        if(this.conversation.external == true){
          this.conversation_id.group_userid.external_userid=this.$route.query.tolist
        }else{
          this.conversation_id.group_userid.userid=this.$route.query.tolist
        }
      }
    },


    //全部 显示隐藏
    all() {
      this.lujing()
      this.liaotjl = [];
      this.yeshu = 1;
      this.right.all = true; //全部 显示隐藏
      this.right.file = false; // 文件 显示隐藏
      this.right.picture = false; //图片 显示隐藏
      this.right.red = false; // 红包 显示隐藏
      this.right.voice = false; //语音 显示隐藏
      this.right.video = false; //视频 显示隐藏
      this.fenlei = "";
      this.isInfiniteScrollDisabled = true;
      if (this.conversation.interior == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.group == true) {
        this.axios
            .post(
                "/home/department/getChatContent",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  content: this.input3,
                  id: this.conversation_id.chat_id.id,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  name: this.conversation_id.chat_id.name,
                  status: this.conversation_id.chat_id.status,
                  owner: this.conversation_id.chat_id.owner,
                  create_time: this.conversation_id.chat_id.create_time,
                  account_id: this.conversation_id.chat_id.account_id,
                  label_group_id:this.conversation_id.chat_id.label_group_id ,
                  notice: this.conversation_id.chat_id.notice,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {

              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.conversation_id.group_userid = res.data.data;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.external == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  msgtype: this.fenlei,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.external_userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      }
    },
    // 文件 显示隐藏
    file() {
      this.lujing()
      this.liaotjl = [];
      this.yeshu = 1;
      this.right.all = false; //全部 显示隐藏
      this.right.file = true; // 文件 显示隐藏
      this.right.picture = false; //图片 显示隐藏
      this.right.red = false; // 红包 显示隐藏
      this.right.voice = false; //语音 显示隐藏
      this.right.video = false; //视频 显示隐藏
      this.fenlei = "file";
      this.isInfiniteScrollDisabled = true;
      if (this.conversation.interior == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  msgtype: this.fenlei,
                  page: this.yeshu,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.group == true) {
        this.axios
            .post(
                "/home/department/getChatContent",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  content: this.input3,
                  id: this.conversation_id.chat_id.id,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  name: this.conversation_id.chat_id.name,
                  status: this.conversation_id.chat_id.status,
                  owner: this.conversation_id.chat_id.owner,
                  create_time: this.conversation_id.chat_id.create_time,
                  account_id: this.conversation_id.chat_id.account_id,
                  label_group_id:this.conversation_id.chat_id.label_group_id ,
                  notice: this.conversation_id.chat_id.notice,

                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.conversation_id.group_userid = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.external == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  msgtype: this.fenlei,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.external_userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              // console.log(res);
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
              // // console.log(this.data);
            })
            .catch(function (err) {
              // // console.log(err);
            });
      }
    },
    //图片 显示隐藏
    picture() {
      this.lujing()
      this.liaotjl = [];
      this.yeshu = 1;
      this.right.all = false; //全部 显示隐藏
      this.right.file = false; // 文件 显示隐藏
      this.right.picture = true; //图片 显示隐藏
      this.right.red = false; // 红包 显示隐藏
      this.right.voice = false; //语音 显示隐藏
      this.right.video = false; //视频 显示隐藏
      this.fenlei = "image";
      this.isInfiniteScrollDisabled = true;
      if (this.conversation.interior == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.group == true) {
        this.axios
            .post(
                "/home/department/getChatContent",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  content: this.input3,
                  id: this.conversation_id.chat_id.id,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  name: this.conversation_id.chat_id.name,
                  status: this.conversation_id.chat_id.status,
                  owner: this.conversation_id.chat_id.owner,
                  create_time: this.conversation_id.chat_id.create_time,
                  account_id: this.conversation_id.chat_id.account_id,
                  label_group_id:this.conversation_id.chat_id.label_group_id ,
                  notice: this.conversation_id.chat_id.notice,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.conversation_id.group_userid = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.external == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  msgtype: this.fenlei,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.external_userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      }
    },
    // 红包 显示隐藏
    red() {
      this.lujing()
      this.liaotjl = [];
      this.yeshu = 1;
      this.right.all = false; //全部 显示隐藏
      this.right.file = false; // 文件 显示隐藏
      this.right.picture = false; //图片 显示隐藏
      this.right.red = true; // 红包 显示隐藏
      this.right.voice = false; //语音 显示隐藏
      this.right.video = false; //视频 显示隐藏
      this.fenlei = "redpacket";
      this.isInfiniteScrollDisabled = true;
      if (this.conversation.interior == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.group == true) {
        this.axios
            .post(
                "/home/department/getChatContent",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  content: this.input3,
                  id: this.conversation_id.chat_id.id,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  name: this.conversation_id.chat_id.name,
                  status: this.conversation_id.chat_id.status,
                  owner: this.conversation_id.chat_id.owner,
                  create_time: this.conversation_id.chat_id.create_time,
                  account_id: this.conversation_id.chat_id.account_id,
                  label_group_id:this.conversation_id.chat_id.label_group_id ,
                  notice: this.conversation_id.chat_id.notice,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.conversation_id.group_userid = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.external == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  msgtype: this.fenlei,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.external_userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      }
    },
    //语音 显示隐藏
    voice() {
      this.lujing()
      this.liaotjl = [];
      this.yeshu = 1;
      this.right.all = false; //全部 显示隐藏
      this.right.file = false; // 文件 显示隐藏
      this.right.picture = false; //图片 显示隐藏
      this.right.red = false; // 红包 显示隐藏
      this.right.voice = true; //语音 显示隐藏
      this.right.video = false; //视频 显示隐藏
      this.fenlei = "voice";
      this.isInfiniteScrollDisabled = true;
      if (this.conversation.interior == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  msgtype: this.fenlei,
                  page: this.yeshu,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.group == true) {
        this.axios
            .post(
                "/home/department/getChatContent",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  content: this.input3,
                  id: this.conversation_id.chat_id.id,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  name: this.conversation_id.chat_id.name,
                  status: this.conversation_id.chat_id.status,
                  owner: this.conversation_id.chat_id.owner,
                  create_time: this.conversation_id.chat_id.create_time,
                  account_id: this.conversation_id.chat_id.account_id,
                  label_group_id:this.conversation_id.chat_id.label_group_id ,
                  notice: this.conversation_id.chat_id.notice,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.conversation_id.group_userid = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.external == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  msgtype: this.fenlei,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.external_userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      }
    },
    // 视频
    video() {
      this.lujing()
      this.liaotjl = [];
      this.yeshu = 1;
      this.right.all = false; //全部 显示隐藏
      this.right.file = false; // 文件 显示隐藏
      this.right.picture = false; //图片 显示隐藏
      this.right.red = false; // 红包 显示隐藏
      this.right.voice = false; //语音 显示隐藏
      this.right.video = true; //视频 显示隐藏
      this.fenlei = "video";
      this.isInfiniteScrollDisabled = true;
      if (this.conversation.interior == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  msgtype: this.fenlei,
                  page: this.yeshu,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.group == true) {
        this.axios
            .post(
                "/home/department/getChatContent",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  msgtype: this.fenlei,
                  content: this.input3,
                  id: this.conversation_id.chat_id.id,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  name: this.conversation_id.chat_id.name,
                  status: this.conversation_id.chat_id.status,
                  owner: this.conversation_id.chat_id.owner,
                  create_time: this.conversation_id.chat_id.create_time,
                  account_id: this.conversation_id.chat_id.account_id,
                  label_group_id:this.conversation_id.chat_id.label_group_id ,
                  notice: this.conversation_id.chat_id.notice,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.conversation_id.group_userid = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.external == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  msgtype: this.fenlei,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.external_userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              this.liaotjl = res.data.data;
              this.yeshu++;
              this.isInfiniteScrollDisabled = false;
            })
            .catch(function (err) {
              console.log(err);
            });
      }
    },
    load() {
      this.lujing()
      //  this.liaotjl = []
      // this.yeshu += 1;
      if (this.conversation.interior == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  msgtype: this.fenlei,
                  page: this.yeshu,
                  content: this.input3,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              res.data.data.forEach((item) => {
                this.liaotjl.push(item);
              });
              this.yeshu++;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.group == true) {
        this.axios
            .post(
                "/home/department/getChatContent",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  msgtype: this.fenlei,
                  page: this.yeshu,
                  content: this.input3,
                  id: this.conversation_id.chat_id.id,
                  chat_id: this.conversation_id.chat_id.chat_id,
                  name: this.conversation_id.chat_id.name,
                  status: this.conversation_id.chat_id.status,
                  owner: this.conversation_id.chat_id.owner,
                  create_time: this.conversation_id.chat_id.create_time,
                  account_id: this.conversation_id.chat_id.account_id,
                  label_group_id:this.conversation_id.chat_id.label_group_id ,
                  notice: this.conversation_id.chat_id.notice,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              console.log(res);
              // res.data.data.forEach((item) => {
              //   this.liaotjl.push(item);
              // });
              this.liaotjl = this.liaotjl.concat(res.data.data);
              res.data.data.forEach((item) => {
                this.conversation_id.group_userid.push(item);
              });
              this.yeshu++;
            })
            .catch(function (err) {
              console.log(err);
            });
      } else if (this.conversation.external == true) {

        this.axios
            .post(
                "/home/record/getChatInfo",
                qs.stringify({
                  usertoken: this.tooken.usertoken,
                  account_id: this.tooken.account_id,
                  phone: this.tooken.phone,
                  msgtype: this.fenlei,
                  start_time: this.kaissj,
                  end_time: this.jssj,
                  page: this.yeshu,
                  content: this.input3,
                  from: this.conversation_id.dataid_userid.userid,
                  tolist: this.conversation_id.group_userid.external_userid,
                }),
                { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/register");
              }
              res.data.data.forEach((item) => {
                this.liaotjl.push(item);
              });
              this.yeshu++;
            })
            .catch(function (err) {
              console.log(err);
            });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.buoo {
  /* transform: rotateX(180deg); */
  width: 200px !important;
  height: 30px !important;
  /* transform: rotateY(180deg); */
  /* color: rgb(255, 79, 79) */
}

.x-time {
  right: 100px !important;
}

.x-sector {
  transform: rotateY(180deg) !important;
}

.if_status {
  color: blue;
}

.tongg {
  color: red;
}

.wei_body {
  margin-top: 42px;
  width: 1671px;
  height: 942px;
  background-color: #ffffff;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.2);
  padding: 23px 31px;
}

.tianjia {
  width: 100%;
  height: 100%;
}

.tianjia>main {
  font-size: 26px;
  /* margin-bottom: 40px; */
}

.a {
  background-color: #2890dd;
  color: #ffffff;
}

.bule {
  width: 100%;
  height: 69px;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: 0px;
  left: 0px;
}

.show {
  display: inline-block;
}

.conceal {
  display: none;
}

.staffo_home {
  width: 100%;
  height: 100%;
  /* background-color: red; */
  /* border: 2px solid rgba(210,210,210,1); */
}

.one {
  width: 25%;
  border: 1px solid #eee;
  border-right: none;
  height: 100%;
  display: inline-block;
  overflow: hidden;
}

.two {
  height: 100%;
  width: 25%;
  border: 1px solid #eee;
  border-right: none;
  display: inline-block;
  overflow: hidden;
}

.aboutno {
  width: 200px;
}

.three {
  height: 100%;
  width: 50%;
  border: 1px solid #eee;
  display: inline-block;
  overflow: hidden;
}

.staffo_home_nav {
  width: 100%;
  min-height: 43px;
  display: inline-flex;
  align-items: center;
  background-color: #f8f8f8;
  color: #19273c;
 justify-content: space-around;
}

.staffo_home_nav>span {
  font-size: 16px;
}

.staffo_home_body {
  width: 100%;
  height: 662px;
  background: #fdfefd;
  overflow: hidden;
  overflow-y: auto;
  padding-top: 12px;
}

.select {
  width: 100%;
  /* background-color: red; */
  margin-top: 20px;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-around;
}

.select>span {
  font-size: 16px;
  /* font-weight: 100; */

  cursor: pointer;
  /* margin-left: 30px; */
}

.select>span:hover{
  color: #49B372;
}
.staff>span:hover{
  color: #49B372 !important;
}
 .gain {
  color: #49B372;
}

.no_gain {
  color: #4c4c4c;
}
.staff {
  width: 100%;
  height: 40px;
  font-size: 16px;
  margin-top: 20px;
  display: flex;
  justify-content: space-around;
}

.staff>span {
  cursor: pointer;
}

.staff>span:hover {
  color: #3088db;
}

.overview {
  width: 100%;
  height: 742px;
  /* background-color: #2890dd; */
  padding: 15px 0;
  background: rgba(250, 253, 255, 1);
  border: 2px solid rgba(210, 210, 210, 1);
}

.overview_nav {
  width: 100%;
  height: 50px;
  /* background-color: #2890dd; */
}

.overview_nav>span {
  margin-right: 20px;
}

.overview_body {
  width: 100%;
  height: 674px;
  overflow: hidden;
  overflow-y: auto;
}

.leix>span {
  position: relative;
  bottom: 2px;
}

.el-tree-node__content {
  width: 100%;
}

.staffo_home_body_section {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  font-size: 16px;
}

.chatting_records {
  width: 90%;
  margin-top: 20px;
  margin-left: 5%;
  height: 500px;
  background-color: #ffffff;
  /* background-color: rgb(245,245,245); */
  padding: 10px;
  overflow: hidden;
  overflow-y: auto;
}

.chatting_records_fasong {
  /* float: left; */
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
  margin-bottom: 10px;
  justify-content: flex-end;
}

.touxiang {
  width: 50px;
  height: 50px;
}

.information {
  display: inline-block;
  max-width: 70%;
  margin-right: 10px;
}

.information_name {
  margin-bottom: 5px;
  /* margin-left: 5px; */
  text-align: right;
  color: #999999;
}

.conversation_body {
  box-shadow: 0px 1px 3px 0px rgba(167, 167, 167, 0.2);
  padding: 10px;
  border-radius: 3px;
  min-height: 2rem;
  background-color: rgba(255, 255, 255);
  float: right;
}

.name_docmsg {
  width: 300px;
  height: 100px;
  /* background-color: red; */
  color: black;
}

.name_docmsg_name {
  width: 180px;
  height: 3em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  top: 20px;
}

.name_docmsg_haha {
  font-size: 16px;
  color: rgb(181, 181, 181);
  margin-top: 20px;
}

/* 文档在线文档 */
.abc {
  display: inline-block;
}

.name_docmsg>img {
  margin-left: 40px;
  margin-bottom: 25px;
}

/* 直播css */
.link_zhibo {
  width: 300px;
  height: 100px;
  /* background-color: red;  */
}

.link_imges {
  width: 100%;
  height: 40px;
  /* background-color: yellow; */
}

.link_imges>img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.link_imges>span {
  font-size: 16px;
  color: rgb(181, 181, 181);
  position: relative;
  left: 10px;
  top: -8px;
}

.link_biaoti {
  margin-top: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 小程序 */
.weapp_body {
  width: 300px;
  /* height: 400px; */
  /* background-color: red; */
}

.weapp_nav {
  width: 300px;
  height: 50px;
  /* background-color: yellow; */
  z-index: 10;
}

.weapp_imgs {
  width: 300px;
  /* height: 300px; */
  /* background-color: rebeccapurple; */
}

.weapp_bottom {
  width: 300px;
  /* height: 50px; */
  /* background-color: black; */
}

.weapp_img {
  display: inline-block;
  width: 30px;
  height: 30px;
  position: relative;
  left: 10px;
  top: 10px;
  /* background-color: blue; */
  z-index: 1000;
}

.weapp_text {
  display: inline-block;
  position: relative;
  left: 20px;
  top: 0px;
  color: #999999;
  font-size: 16px;
}

.weapp_imgs_text {
  width: 300px;
  /* height: 100px; */
  /* background-color: yellow; */
  padding-bottom: 10px;
}

.weapp_imgs_img {
  width: 300px;
  /* height: 250px; */
  /* background-color: aqua; */
  padding-bottom: 15px;
  /* background-color: rgb(245, 249, 252); */
}

.weapp_bottom {
  padding: 12px;
  border-top: 1px solid rgb(230, 230, 230);
  padding-bottom: 0;
}

.weapp_bottom>img {
  width: 20px;
  height: 20px;
}

.weapp_bottom>span {
  position: relative;
  font-size: 16px;
  color: #999999;
  left: 10px;
  bottom: 3px;
}

.sbe {
  width: 150px;
  height: 225px;
  background-image: url("../../assets/5dfee87ed8c4e7f093b94a2f96a64d1.png");
  background-size: 100%;
}

.sbe_body {
  width: 100%;
  height: 100%;
  position: relative;
  padding: 10%;
}

.sbe_body>div:nth-child(1) {
  text-align: center;
  color: #e0b56a;
  font-size: 16px;
  margin-top: 50px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sbe_body>div:nth-child(2) {
  /* position: absolute; */
  text-align: center;
  font-size: 13px;
  margin-top: 75px;
}

no {
  max-width: 200px;
  max-height: 200px;
}

.conference {
  width: 300px;
  height: 150px;
  /* background-color: red; */
}

.conference>div:nth-child(1) {
  width: 100%;
  height: 35px;
  /* background-color: black; */
}

.conference>div:nth-child(2) {
  width: 100%;
  height: 80px;
  /* background-color: blue; */
  padding: 10px;
  text-align: center;
}

.conference>div:nth-child(2)>div {
  width: 100%;
  height: 100%;
  padding-top: 20px;
  background-color: rgba(251, 251, 251, 1);
  color: rgba(106, 106, 106);
}

.conference>div:nth-child(3) {
  width: 100%;
  height: 35px;
  border-top: 1px solid rgb(230, 230, 230);
  padding-top: 5px;
  color: rgba(163, 163, 163);
  /* background-color: yellow; */
}

.else_left {
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-top: 10px;
  margin-bottom: 10px;
}

.else_left>img {
  width: 50px;
  height: 50px;
}

.name_left {
  display: inline-block;
  max-width: 70%;
  margin-left: 10px;
}

.conversation_left {
  box-shadow: 0px 1px 3px 0px rgba(167, 167, 167, 0.2);
  padding: 10px;
  border-radius: 3px;
  min-height: 2rem;
  background-color: rgba(255, 255, 255);
  float: left;
}

.information_left {
  margin-bottom: 5px;
  text-align: left;
  color: #999999;
}

.mnbm {
  width: 300px;
  height: 300px;
}
::v-deep .el-tree-node__expand-icon.is-leaf{
  display: none;
}
::v-deep .el-tree-node__content{
  justify-content: space-around;
}
</style>
